module.exports = __webpack_public_path__ + "media/images/sindma/icon-normativa-f7cd9e5236b3bb68a077c056e47d1f66.png";